// src/ui/components/list/Ranking.tsx
import React, { useEffect, useState } from 'react';
import ItemRankingCustom from '../items/ItemRankinCustom';
import { RankingItem } from '../../../core/models/RankingItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import type SwiperCore from 'swiper'; // importa el tipo
import IndicatorDots from '../utils/IndicatorDots';
import 'swiper/css';
import 'swiper/css/effect-fade';
interface RankingProps {
  items: RankingItem[];
  title?: string;
  blockId: number;
  intensityCategoryId: number;
  ratingTypeId: number;
  onEmpty?: () => void;
}

const Ranking: React.FC<RankingProps> = ({ title, items, onEmpty }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  // 1) Detectar vacío y notificar
  useEffect(() => {
    if (items.length === 0 && onEmpty) {
      onEmpty();
    }
  }, [items, onEmpty]);

  // 2) Si no hay items, no renderizamos nada
  if (items.length === 0) {
    return null;
  }

  // 2) Decide si usamos carrusel (más de 2 bloques)
  const useCarousel = items.length > 2;
  // Número de slides, 2 items por slide
  const slideCount = Math.ceil(items.length / 2);
  const slides: RankingItem[][] = Array.from({ length: slideCount }, (_, idx) => {
    const first = items[2 * idx];
    const second = items[2 * idx + 1];
    return second ? [first, second] : [first];
  });

  return (
    <>
      <div className="flex items-center justify-between w-full mb-6">
        <h2 className="text-2xl font-semibold">Ranking Diario</h2>
        <IndicatorDots
          count={useCarousel ? slides.length : 1}
          activeIndex={activeSlide}
          activeColor="bg-white"
          inactiveColor="bg-gray-200/50"
        />
      </div>
      <div className="col-span-1 bg-gray-200/25 shadow hover:shadow-md overflow-hidden rounded-[24px] p-6">
        {title && <h2 className="text-lg font-semibold">{title}</h2>}

        <Swiper
          modules={[Autoplay, EffectFade]}
          slidesPerView={1}
          autoplay={{ delay: 3000, disableOnInteraction: true }}
          speed={600}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          onSlideChange={(swiper: SwiperCore) => {
            // swiper.activeIndex es number
            const realIndex = swiper.activeIndex % slides.length;
            setActiveSlide(realIndex);
          }}
        >
          {slides.map((group, idx) => (
            <SwiperSlide key={`slide-${idx}`}>
              <ol className="list-decimal list-inside space-y-2">
                {group.map((it, j) => (
                  <li key={`${it.blockId}-${j}`} className="flex items-center space-x-3">
                    <ItemRankingCustom
                      img={it.user_info.pictureUrl || '/default-avatar.png'}
                      name={`${it.user_info.name}`}
                      rating={`${it.rating}`}
                      position={j + 1 + idx * slideCount}
                    />
                  </li>
                ))}
              </ol>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* <div className="flex justify-center pt-2">
        <IndicatorDots
          count={slides.length}
          activeIndex={activeSlide}
          size={2}
          activeColor="bg-white"
          inactiveColor="bg-gray-200/50"
        />
      </div> */}
      </div>
    </>
  );
};

export default React.memo(Ranking);
